export function forEachEnumKeyVal<TKey extends string, TValue>(
  object: Record<TKey, TValue>,
  callback: (key: keyof typeof object, value: TValue) => void,
) {
  Object.keys(object).forEach((key) => callback(key as TKey, object[key as TKey]));
}
